/* eslint-disable */
// <defs><style>.cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}</style>
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';
export const SvgPinkTouchId = ({ size }) => {
    return(
    <Svg 
    height={size}
    width={size}  x={0} y={0}
    viewBox="0 0 341 349" 
    enable-background="new 0 0 341 349">
<G>
	<G>
		<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M53.273,115.196
			c-13.312,25.995-18.245,56.509-12.023,87.365"/>
		<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M231.293,55.945
			c-25.543-12.538-55.271-17.06-85.321-11.001c-34.136,6.882-62.593,26.187-81.618,52.257"/>
		<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M303.582,149.664
			c-7.061-35.013-27.189-64.056-54.285-83.07"/>
	</G>
</G>
<G>
	<G>
		<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M306.295,178.805
			c0.184-9.594-0.666-19.356-2.641-29.154"/>
		<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M41.322,202.547
			c0.388,1.921,0.814,3.824,1.279,5.709"/>
	</G>
</G>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M137.872,305.398
	c29.977-34.118,44.249-81.34,34.579-129.293"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M149.594,254.448
	c-6.555,16.797-16.443,32.13-29.02,45.026"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M156.604,309.005
	c29.05-37.175,42.302-86.333,32.246-136.205l0.051-0.017c-1.836-9.104-10.702-14.996-19.807-13.16
	c-9.103,1.836-14.994,10.703-13.159,19.809l0.119-0.021c3.746,18.582,3.45,37.04-0.284,54.465"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M140.928,190.253
	c5.245,38.701-9.215,76.082-36.162,101.293"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M208.912,205.543
	c-0.033-11.891-1.227-23.95-3.666-36.049l0.037-0.014c-3.659-18.152-21.34-29.901-39.492-26.24
	c-13.559,2.734-23.546,13.292-26.203,26.027"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M176.691,309.857
	c16.744-24.469,27.605-52.939,31.045-83.099"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M176.348,126.008
	c-4.529-0.353-9.184-0.093-13.858,0.85c-27.201,5.485-44.805,31.979-39.32,59.182l0.094-0.017
	c7.418,36.793-6.293,72.939-32.779,95.877"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M198.025,307.434
	c24.108-41.097,33.776-90.867,23.617-141.246l0.024-0.01c-3.022-14.988-12.424-27.062-24.808-33.967"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M102.875,236.102
	c-5.228,13.461-13.877,25.422-25.095,34.611"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M239.502,241.169
	c4.162-25.267,3.9-51.696-1.461-78.287l0.01-0.007c-7.31-36.25-42.617-59.709-78.865-52.4c-36.25,7.31-59.71,42.618-52.4,78.869
	l0.078-0.015c1.736,8.61,2.084,17.177,1.197,25.469"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M220.424,301.02
	c6.068-12.457,10.967-25.521,14.582-39.021"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M240.084,126.867
	c6.883,9.447,11.887,20.496,14.35,32.705l0.006,0.004c9.095,45.104,4.562,89.789-10.744,129.806"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M137.488,100.061
	c5.76-2.64,11.913-4.663,18.393-5.969c25.609-5.163,50.842,1.962,69.588,17.315"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M66.693,258.159
	c18.902-15.185,28.896-40.119,23.771-65.525l-0.063,0.015c-6.366-31.566,5.94-62.562,29.315-81.543"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M72.102,180.085
	c0.215,5.25,0.844,10.552,1.916,15.867l0.051-0.013c3.752,18.607-3.295,36.882-16.821,48.343"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M273.107,169.265
	c-0.642-4.326-1.398-8.658-2.271-12.994l-0.02-0.001c-10.959-54.348-63.894-89.518-118.238-78.561
	c-41.765,8.422-72.207,41.635-79.088,81.229"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M267.4,270.367
	c6.826-25.604,9.664-52.565,7.932-80.029"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M188.105,60.04
	c-12.592-1.701-25.675-1.366-38.831,1.287C85.879,74.109,44.85,135.859,57.633,199.256l0.039-0.01
	c2.219,11-1.225,21.822-8.312,29.47"/>
<Path fill="none" stroke="#E5078B" strokeWidth="8" strokeLinecap="round" stroke-miterlimit="10" d="M290.521,239.006
	c3.479-27.945,2.584-56.916-3.289-86.041l-0.033,0.002c-8.693-43.112-40.031-75.878-79.129-88.413"/>
</Svg>
    )
    
}

